import React from "react";
import { NavLink } from "react-router-dom";
import AuthProvider from "../../../providers/Auth.Provider";
import { toast } from "react-toastify";

const MainNavigation = () => {
    const { admin } = AuthProvider.authProvider.GetAuthenticatedStaff();
    return (
        <div className="mr-2 ml-2">
            <ul className="nav nav-tabs nav-justified">
                <li className="nav-item linker">
                    <NavLink to="/home/clinical-note/ward-summary" activeClassName="active show">
                        <i className="fa fa-users" aria-hidden="true"></i>
                        <span> Ward Summary</span>
                    </NavLink>
                </li>
                <li className="nav-item linker">
                    <NavLink activeClassName="active show" to="/home/clinical-note/appointment">
                        <i className="fa fa-hospital-o" aria-hidden="true"></i> <span>Appointment</span>
                    </NavLink>
                </li>

                <li className="nav-item linker">
                    <NavLink exact activeClassName="active show" to="/home/clinical-note">
                        <i className="fa fa-pie-chart" aria-hidden="true"></i> <span>Dashboard</span>
                    </NavLink>
                </li>
                <li className="nav-item linker">
                    <NavLink exact activeClassName="active show" to="/home/clinical-note/scanner">
                        <i className="fa fa-qrcode" aria-hidden="true"></i> <span>QR Scanner</span>
                    </NavLink>
                </li>
                <li className="nav-item linker">
                    {admin ? (
                        <NavLink to="/home/clinical-note/admin" activeClassName="active show">
                            <i className="fa fa-user-secret" aria-hidden="true"></i> <span>Administrator</span>
                        </NavLink>
                    ) : (
                        <a href="#!" onClick={() => toast.error("You are not allowed to access this page!")} className="">
                            <i className="fa fa-user-secret" aria-hidden="true"></i> <span>Administrator</span>
                        </a>
                    )}
                </li>
            </ul>
        </div>
    );
};

export default MainNavigation;
